import { memo } from "react";
import { Box, Grid, Typography } from '@mui/material';
import ThermometerChart from '../../../components/common/Thermometer';

const Temperature = ({ title, minValue, maxValue, lowerLimit, upperLimit, unit, sx }) => {
	return (
		<Grid xs={12} lg={8} md={6} ml={2}>
			<Box display="flex" textAlign="center" sx={sx}>
				<Typography flex={1} fontWeight="bold" variant="body2" gutterBottom>
					{title} {(unit)}
				</Typography>
			</Box>
			<Box p={1}>
				<ThermometerChart
					title={title}
					minValue={minValue}
					maxValue={maxValue}
					lowerLimit={lowerLimit}
					upperLimit={upperLimit}
					unit={unit}
					hideMaxLimitText={true}
					minLimitText={`${minValue} ${unit}`}
				/>
			</Box>
		</Grid>
	);
};

export default memo(Temperature);